import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChatusersModalPage } from './chatusers-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ChatusersModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChatusersModalPageRoutingModule {}
